import { EWorkflowStepHandlerRoleTeam, EWorkflowStepUserType, EWorkflowStepHandlerFromTarget, EWorkflowType } from "src/enums";
import { IWorkflowStepHandlerRoleTeam } from "src/models/workflow";

export const PAGE_SIZE = 15;   // 分页大小
export const TOASTER_TIMEOUT = 10000;    // toaster默认展示时间（10s）
export const TOASTER_TIMEOUT_INFINITY = -1;    // toaster展示时间无限长（不自动关闭，须手动关闭）
export const ERROR_SKIP_WAITING_TIME = 2000;  // 页面报错，跳转到其他页面的等待时间（2s）
export const PROJECT_OVERDUE_TIME = 2 * 24 * 3600 * 1000;  // 新项目逾期时间为2天
export const ROOT_PARENT_ORG_NUMBER = '00000000000000000000000000000000';  // 一级组织的parent_org_number
export const PROJECT_SN_PREFIX = '序号';  // 项目的 _sn 前加上前缀，用于 http 拦截器判断是项目数据错误
export const DELAY_REFRESH_TIME = 1200; // 延迟刷新页面获取列表

//#region 项目中心-项目列表
export const ROOT_PROJECT_ID = '0'; // 根项目的id（一级项目的parent_id）
export const PROJECTS_OPTIONS_PARAMS_MAPPING = {    // 项目筛选条件-项目列表请求参数 对照表
  roles: { paramKey: 'role', title: '项目角色' },
  statuses: { paramKey: 'status', title: '流程状态' },
  types: { paramKey: 'type', title: '项目类型' },
  levels: { paramKey: 'level', title: '项目级别' },
  groups: { paramKey: 'group', title: '项目群' },
  lights: { paramKey: 'light', title: '状态' },
  categories: { paramKey: 'category', title: '业务分类' },
  sorting_ways: { paramKey: 'order', title: '排序规则' }
};
export const PROJECT_MORE_FILTERS_KEYS =
  ['status', 'type', 'level', 'group', 'light', 'category', 'organization'];  // 项目中心筛选条件，更多条件的keys（决定”更多条件“的折叠/展开转台）
//#endregion

//#region 项目下发列表
export const ROOT_PROJECT_PUID = ''; // 根项目的puid（一级项目的parent_puid）
export const LEVEL_ONE_PROJECT_ID_LEVEL = 1; // 一级项目的id_level（二、三级项目依次+1）
export const MAX_PROJECT_ID_LEVEL = 5; // 最多允许创建的项目层级
//#endregion

//#region 工作流
export const WORKFLOW_STEP_PERSON_LIMIT_INFINITE = null; // 工作流节点审批人数量无限制
export const WORKFLOW_STEP_START_RANK = 0;  // 工作流开始节点的rank值
export const WORKFLOW_STEP_DEFAULT_HANDLER_INFOS: { // 工作流节点自动带人信息配置列表
  userType: EWorkflowStepUserType; // 工作流节点审批人类型
  target: EWorkflowStepHandlerFromTarget;  // 
  handlerId: string; // 对应项目的干系人 key 属性
  handlerName: string;  // 对应项目的干系人 name 属性
}[] = [
    {// 创建人
      userType: EWorkflowStepUserType.ProjectCreator,
      target: EWorkflowStepHandlerFromTarget.Project,
      handlerId: 'created_by',
      handlerName: 'created_name'
    },
    { // 管理员
      userType: EWorkflowStepUserType.ProjectManager,
      target: EWorkflowStepHandlerFromTarget.Project,
      handlerId: 'manage_by',
      handlerName: 'manager'
    },
    {// 指令人
      userType: EWorkflowStepUserType.ProjectAssigner,
      target: EWorkflowStepHandlerFromTarget.Project,
      handlerId: 'assigner_id',
      handlerName: 'assigner'
    },
    {// 责任人
      userType: EWorkflowStepUserType.ProjectPersonLiable,
      target: EWorkflowStepHandlerFromTarget.Project,
      handlerId: 'person_liable_id',
      handlerName: 'person_liable'
    },
    {// 验收人
      userType: EWorkflowStepUserType.ProjectAccepter,
      target: EWorkflowStepHandlerFromTarget.Project,
      handlerId: 'accepter_id',
      handlerName: 'accepter'
    },
    {// 第二责任人
      userType: EWorkflowStepUserType.ProjectSecondPersonLiable,
      target: EWorkflowStepHandlerFromTarget.Project,
      handlerId: 'other_person_liable_accounts',
      handlerName: 'other_person_liable_names'
    },
    {// 流程提交人
      userType: EWorkflowStepUserType.WorkflowSubmitUser,
      target: EWorkflowStepHandlerFromTarget.Audit,
      handlerId: 'created_by',
      handlerName: 'created_by_name'
    },
    {// 过程调度责任人
      userType: EWorkflowStepUserType.SchedulePersonLiable,
      target: EWorkflowStepHandlerFromTarget.Schedule,
      handlerId: 'responsible_person_id',
      handlerName: 'responsible_person_name'
    },
    {// 过程调度发起人
      userType: EWorkflowStepUserType.ScheduleCreator,
      target: EWorkflowStepHandlerFromTarget.Audit,
      handlerId: 'created_by',
      handlerName: 'created_by_name'
    },
    {// 流程责任人
      userType: EWorkflowStepUserType._WorkflowPersonLiable,
      target: EWorkflowStepHandlerFromTarget.Audit,
      handlerId: 'responsible_person',
      handlerName: 'responsible_person_name'
    }
  ];
// 工作流默认审批人列表
export const WORKFLOW_STEP_DEFAULT_HANDLER_TEAMS: IWorkflowStepHandlerRoleTeam[] = [{
  label: '自选用户',
  value: EWorkflowStepHandlerRoleTeam.Custom,
  children: [{
    label: '任意',
    value: EWorkflowStepUserType.CustomUser
  }]
}, {
  label: '指定角色',
  value: EWorkflowStepHandlerRoleTeam.SpecificRole,
  children: [{
    label: '项目创建人',
    value: EWorkflowStepUserType.ProjectCreator
  }, {
    label: '管理员',
    value: EWorkflowStepUserType.ProjectManager
  }, {
    label: '指令人',
    value: EWorkflowStepUserType.ProjectAssigner
  }, {
    label: '责任人',
    value: EWorkflowStepUserType.ProjectPersonLiable
  // }, {
  //   label: '第二责任人',
  //   value: EWorkflowStepUserType.ProjectSecondPersonLiable
  }, {
    label: '流程提交人',
    value: EWorkflowStepUserType.WorkflowSubmitUser
  }, {
    label: '验收人',
    value: EWorkflowStepUserType.ProjectAccepter
  }, {
    label: '过程调度责任人',
    value: EWorkflowStepUserType.SchedulePersonLiable,
    workflowType: EWorkflowType.ProcessSchedule
  }, {
    label: '过程调度发起人',
    value: EWorkflowStepUserType.ScheduleCreator,
    workflowType: EWorkflowType.ProcessSchedule
  }]
}];
//#endregion

//#region 抄送
export const CAN_COPY_WORKFLOW_STEP_NAMES = ['修订'];   // 可进行抄送的审批流节点名称列表（审批流的当前节点可抄送 && 当前用户是当前节点上的审批人，则可进行抄送）
//#endregion

// 路由地址
export const ROUTE_URLS = {
  PROJECT_ISSUE_UNSENT: '/works/project-issue-unsent', // 工作中心-立项发布-已下发
  PROJECT_ISSUE_SENDING: '/works/project-issue-sending', // 工作中心-立项发布-下发中
  PROJECT_ISSUE_SENT: '/works/project-issue-sent', // 工作中心-立项发布-已下发
  PROJECT_DETAIL: '/works/project-detail/',    // {puid} 工作中心-立项发布-已下发-项目详情页 
  WORKFLOW_UNAPPROVED: '/works/workflow-unapproved',  // 工作中心-流程审批-待审批
  WORKFLOW_APPROVED: '/works/workflow-approved',  // 工作中心-流程审批-已审批
  RECEIPT_TODO: '/works/receipt-unsent',    // 工作中心-项目回执-待回执
  RECEIPT_DONE: '/works/receipt-sent',    // 工作中心-项目回执-已回执
  RECEIPT_TRANSFERRED: '/works/receipt-transferred',    // 工作中心-项目回执-已转办
}

// （项目变更单）比较项目是否发生变化，比较的属性
export const PROJECT_COMPARE_PROPERTIES = [
  'puid',
  'parent_puid',
  'title',    // 项目名称
  // '_delay_end_on',    // 完成时间
  // 'end_on',    // 完成时间
  '_end_on',
  'group_codes',  // 项目群
  'type_code',    // 项目类型
  'level_code',   // 项目级别
  'category_code',    // 业务分类
  'accountability_unit_id',   // 责任单位
  'person_liable_id', // 责任人
  'leader_id', // 责任领导
  'assigner_id',  // 指令人
  'manage_by',    // 管理员
  'from_source_code', // 项目来源
  'target',   // 项目目标
  'deliverable',  // 交付物
  'remark',   // 备注
  '_is_need_receipt',  // 是否需要回执
  '_is_secret',    // 保密

  // 会议决议项的属性
  'meeting_title',    // 会议名称
  'other_person_liable_accounts', // 第二责任人
  'accepter_id',  // 验收人
  'content',  // 决议项内容
  'criteria'  // 验收标准/交付物
];

// 禁止上传的文件后缀
export const UPLOAD_FILE_EXTS_BLACK_LIST = ['js', 'bat', 'exe', 'sh', 'doc', 'xls', 'ppt'];